module.exports = __webpack_public_path__ + "static/media/no-link-value.b589d8d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-link-value.svg
// module id = 2451
// module chunks = 0